import React from 'react'
import { Redirect, Route, Switch } from 'react-router'

import VisitsGeneralReport from './VisitsGeneralReport'
import TaskResponsesUserReport from './TaskResponsesUserReport'

export default function Reports() {
	return (
		<React.Fragment>
			<Switch>
				<Redirect exact path="/reports" to="/reports/visits" />

				<Route exact path="/reports/visits" component={VisitsGeneralReport} />
				<Route exact path="/reports/task_responses_user" component={TaskResponsesUserReport} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}